/* Bundle preorder "Estimated Ship" property repair.
 *
 * The bundle app bypasses the theme product form, so
 * snippets/preorder-line-properties.liquid never runs for bundle lines.
 * After the app adds its lines, copy each eligible variant's ship text onto
 * the line while preserving every property the bundle app supplied.
 */
(function () {
  if (window.__mlBundleEb) return;
  window.__mlBundleEb = true;

  var mapEl = document.querySelector('script[data-bundle-preorder-map]');
  var preorderMap = {};
  var patchEnabled = false;

  if (mapEl && mapEl.textContent.trim()) {
    try {
      preorderMap = JSON.parse(mapEl.textContent.trim()) || {};
      patchEnabled = Object.keys(preorderMap).length > 0;
    } catch (error) {
      console.warn('[ml-bundle-eb] Could not read preorder variant map.', error);
    }
  }

  var youthSelectionHandled = false;

  function applyPreorderButtonText() {
    if (!mapEl) return;

    try {
      document.querySelectorAll('.gbbPbAddToCartLabel, .gbbPbAddToCartText')
        .forEach(function (textEl) {
          if (textEl.textContent !== 'Preorder') textEl.textContent = 'Preorder';
        });
    } catch (error) {
      console.warn('[ml-bundle-eb] Could not update bundle preorder button text.', error);
    }
  }

  function removeProductLinkTargets() {
    try {
      document.querySelectorAll('.gbbPbProductCardTitleLink[target]')
        .forEach(function (link) {
          link.removeAttribute('target');
        });
    } catch (error) {
      console.warn('[ml-bundle-eb] Could not update bundle product links.', error);
    }
  }

  function preselectYouth() {
    if (youthSelectionHandled) return;

    try {
      var youthLabel = Array.prototype.find.call(
        document.querySelectorAll('label.labelPickerItem'),
        function (label) {
          var title = (label.getAttribute('title') || '').trim().toLowerCase();
          var textEl = label.querySelector('.labelPickerText');
          var text = textEl ? textEl.textContent.trim().toLowerCase() : '';
          return title === 'youth' || text === 'youth';
        }
      );
      if (!youthLabel) return;

      var youthInput = youthLabel.querySelector('input.labelPickerInput[type="radio"]');
      if (!youthInput) return;

      var inputName = youthInput.getAttribute('name');
      var groupInputs = inputName
        ? Array.prototype.filter.call(
          document.querySelectorAll('input[type="radio"]'),
          function (input) {
            return input.getAttribute('name') === inputName && input.form === youthInput.form;
          }
        )
        : Array.prototype.slice.call(
          (youthLabel.parentElement || youthLabel)
            .querySelectorAll('input.labelPickerInput[type="radio"]')
        );

      if (groupInputs.some(function (input) { return input.checked; })) {
        youthSelectionHandled = true;
        return;
      }
      if (youthInput.disabled) return;

      // Youth's restockrocket_production.preorder_count is 8 versus Baby/Toddler's 3;
      // both launched together under the same 150-unit cap.
      youthLabel.click();
      youthSelectionHandled = true;
    } catch (error) {
      console.warn('[ml-bundle-eb] Could not preselect the Youth bundle option.', error);
    }
  }

  function applyWidgetBehaviors() {
    applyPreorderButtonText();
    removeProductLinkTargets();
    preselectYouth();
  }

  function observeWidget() {
    try {
      // Observe theme-owned markup only; every gbbPb node is app-rendered and replaceable.
      var target = document.querySelector('.product__cart-functions') ||
        document.querySelector('.product-actions') ||
        document.body;
      // Trailing debounce, not a leading one. The app re-renders the widget
      // asynchronously, so a requestAnimationFrame callback fires while it is
      // still writing and our values get overwritten a frame later. Waiting for
      // the mutations to go quiet means we write last. Verified in the live
      // page: a leading rAF reverted on every variant change, a 250ms trailing
      // debounce held through consecutive re-renders.
      var updateTimer = null;
      var observer = new MutationObserver(function () {
        window.clearTimeout(updateTimer);
        updateTimer = window.setTimeout(applyWidgetBehaviors, 250);
      });

      observer.observe(target, {
        attributes: true,
        attributeFilter: ['target'],
        childList: true,
        characterData: true,
        subtree: true
      });
    } catch (error) {
      console.warn('[ml-bundle-eb] Could not observe bundle widget updates.', error);
    }
  }

  observeWidget();
  applyWidgetBehaviors();

  function fetchCart() {
    return fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Cart request failed: HTTP ' + response.status);
      return response.json();
    });
  }

  function displayedCartCount() {
    var countEl = document.querySelector('[data-header-cart-count]');
    if (!countEl) return null;
    var count = parseInt(countEl.textContent, 10);
    return isNaN(count) ? null : count;
  }

  function wait(delay) {
    return new Promise(function (resolve) {
      window.setTimeout(resolve, delay);
    });
  }

  async function waitForBundleAdd(initialCount) {
    var deadline = Date.now() + 8000;
    var delay = 250;

    while (Date.now() < deadline) {
      await wait(Math.min(delay, deadline - Date.now()));
      var cart = await fetchCart();
      if (cart.item_count > initialCount) return cart;
      delay = Math.min(Math.round(delay * 1.5), 1500);
    }

    return null;
  }

  function nextUnpatchedLine(cart) {
    return cart.items.find(function (line) {
      var properties = line.properties || {};
      return Object.prototype.hasOwnProperty.call(properties, '_bundleOfferId') &&
        !Object.prototype.hasOwnProperty.call(properties, 'Estimated Ship') &&
        Object.prototype.hasOwnProperty.call(preorderMap, String(line.variant_id));
    });
  }

  async function patchBundleLines(cart) {
    var currentCart = cart;
    var maxPatches = currentCart.items.length;

    for (var i = 0; i < maxPatches; i += 1) {
      var line = nextUnpatchedLine(currentCart);
      if (!line) break;

      var response = await fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: line.key,
          quantity: line.quantity,
          properties: {
            ...line.properties,
            'Estimated Ship': preorderMap[String(line.variant_id)]
          }
        })
      });

      if (!response.ok) throw new Error('Cart change failed: HTTP ' + response.status);
      currentCart = await response.json();
    }

    // The upcoming /cart navigation replaces refreshCart; refreshing this page's header is dead work.
  }

  var workflow = Promise.resolve();

  document.addEventListener('click', function (event) {
    var button = event.target && event.target.closest
      ? event.target.closest('.gbbPbAddToCartBtn')
      : null;
    if (!button) return;

    var initialCount = displayedCartCount();
    var capturedCount = initialCount === null
      ? fetchCart().then(function (cart) { return cart.item_count; })
      : Promise.resolve(initialCount);

    workflow = Promise.all([workflow, capturedCount])
      .then(async function (values) {
        var cart = await waitForBundleAdd(values[1]);
        if (!cart) return;

        if (patchEnabled) {
          try {
            await patchBundleLines(cart);
          } catch (error) {
            console.warn('[ml-bundle-eb] Could not add Estimated Ship to bundle lines.', error);
          }
        }

        try {
          // Keep EB's redirectToCartEnabled off: its app-timed redirect would race this patch.
          window.location.assign('/cart');
        } catch (error) {
          console.warn('[ml-bundle-eb] Could not navigate to the cart.', error);
        }
      })
      .catch(function (error) {
        console.warn('[ml-bundle-eb] Could not add Estimated Ship to bundle lines.', error);
      });
  }, true);
})();
